<nz-row nzJustify="space-between" nzAlign="middle">
    <nz-col style="margin-bottom: 10px;">
        <input nz-input placeholder="Search..." [(ngModel)]="searchValue" (ngModelChange)="onSearch()" />
    </nz-col>
    <nz-col>
        <button nz-button nzType="primary" (click)="onAdd()">Add</button>
    </nz-col>
</nz-row>

<nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
    <nz-table [nzData]="quotationRequestList" [nzBordered]="true" [nzSize]="'middle'" [nzShowPagination]="false">
        <thead>
            <tr>
                <th>ID</th>
                <th>Type</th>
                <th>Request Title</th>
                <th nzWidth="10%">Due Date</th>
                <th nzWidth="20%">Form</th>
                <!-- <th nzWidth="20%">General Instructions</th> -->
                <th>Created By</th>
                <th nzWidth="8%">Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of quotationRequestList">

                <td><nz-tag>{{ formatIdToFourDigits(item.id) }}</nz-tag></td>
                <td> <img nz-image height="30px" [nzSrc]="getOursouringTypeImage(item)" alt="brand-image-{{item.id}}"
                [nzFallback]="sampleFallbackImage" /> <span style="margin-left: 5px;">  {{ item?.outsourcing_event_request_details?.outsourcing_type_details?.name | titlecase }} </span></td>
                <td>{{ item.request_title }}</td>
                <td>{{ item.due_date | date: 'mediumDate' }}</td>
                <td>{{ item.outsourcing_form_details?.name }}</td>
                <!-- <td>
                    <span nz-tooltip [nzTooltipTitle]="item.general_instructions_for_vendors" nzTooltipPlacement="left">
                        {{ item.general_instructions_for_vendors.length > 50 ?
                        item.general_instructions_for_vendors.substring(0, 50) + '...' :
                        item.general_instructions_for_vendors }}
                    </span>
                </td> -->

                <td>
                    <nz-tag [nzColor]="'cyan'" class="user-badge" [nzBordered]="false">
                            <nz-avatar nzSize="small" *ngIf="item?.created_by_name"
                                [nzText]="item?.created_by_name[0].toUpperCase()" style="margin-right: 4px;"></nz-avatar>
                            {{ item?.created_by_name ? item?.created_by_name : '&nbsp;-' }}
                            </nz-tag>
                </td>

                <td>
                    <button nz-button nzType="default" nzSize="small" (click)="onEditInquery(item)">
                        <nz-icon nzType="edit"  nzTheme="outline" />
                    </button>
                    <button nz-button nzType="default" nzDanger style="margin-left: 10px;" nzSize="small"
                     nz-popconfirm   nzPopconfirmTitle="Are you sure delete this inquiry?"
                        nzPopconfirmPlacement="bottom" (nzOnConfirm)="deleteInquery(item.id)"
                          class="custom-popconfirm"

                          [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
                          [nzPopconfirmTitle]="popconfirmTpl"

                       ><nz-icon nzType="delete" nzTheme="outline" />
                    </button>
                </td>
            </tr>
        </tbody>
    </nz-table>
</nz-spin>

<ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
      <span class="custom-popconfirm-title">
          Confirm Deletion
      </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>
